/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { FetchError, FetchSuccess, fetchV2, fetchV3 } from "..";

export const getAllAdmins = async () => {
  try {
    const res = await fetchV2("admins");
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "An error happened while getting admins");
  }
};

export const getAllAdminsWithSearch = async (offset) => {
  try {
    const res = await fetchV2(`admins/admins?offset=${offset}`, null, {
      page: "/",
    });

    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to search admins");
  }
};

export const searchAdmins = async (offset, search) => {
  try {
    const res = await fetchV2(
      `admins/search?offset=${offset}&search=${search}`,
      null,
      {
        page: "/",
      },
    );

    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to search admins");
  }
};

export const createAdmin = async (admin) => {
  try {
    const res = await fetchV2(`admins`, {
      method: "POST",
      body: JSON.stringify(admin),
    });

    return new FetchSuccess(res, "Admin created successfully");
  } catch (res) {
    throw new FetchError(res, "An error happened while creating admin");
  }
};

export const updateAdmin = async (admin, adminId) => {
  try {
    const res = await fetchV2(`admins/${adminId}`, {
      method: "PATCH",
      body: JSON.stringify(admin),
    });

    return new FetchSuccess(res, "Admin updated successfully");
  } catch (res) {
    throw new FetchError(res, "An error happened while updating admin");
  }
};

export const deleteAdmin = async (adminId) => {
  try {
    const res = await fetchV2(`admins/${adminId}`, {
      method: "DELETE",
    });

    return new FetchSuccess(res, "Admin deleted successfully");
  } catch (res) {
    throw new FetchError(res, "An error happened while deleting admin");
  }
};

export const getAdmin = async (adminId) => {
  try {
    const res = await fetchV2(`admins/${adminId}`);
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "An error happened while getting admin");
  }
};

export const getAdminRoles = async () => {
  try {
    const res = await fetchV3(`get-admin-roles`, null, {
      page: "/",
    });

    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to fetch admin roles");
  }
};
